import {
  filterByCellValueMenuItem,
  HamburgerMenu,
  useCallbackRef,
  useJsonModal,
  useMixpanel,
  type AgGridMenuItems,
  type Column,
  type ColumnDef,
  type Exposure,
  type FilterableProperty,
  type FilterByCellValueParams,
  type UseFilterBuilderOutput,
} from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';
import { compact, isNil } from 'lodash-es';
import { useMemo, type ReactNode } from 'react';
import { colIDToFilterBuilderKey } from './useMarketQuotesFilter';

export function useMarketQuotesMenu({
  openClause,
  filterableProperties,
}: {
  openClause: UseFilterBuilderOutput['addAndOpenClause'];
  filterableProperties: FilterableProperty<string>[];
}): {
  columns: Column[];
  getCustomContextMenuItems: (params: GetContextMenuItemsParams) => AgGridMenuItems;
  dialogs: ReactNode;
} {
  const mixpanel = useMixpanel();
  const { handleClickJson, jsonModal } = useJsonModal();
  const getCustomContextMenuItems = useCallbackRef((params: GetContextMenuItemsParams) => {
    const data = params?.node?.data;
    const groupData = params?.node?.groupData;
    if (isNil(data) && isNil(groupData)) {
      return [];
    }

    return filterByCellValueMenuItem({
      params,
      filterableProperties,
      openClause,
      colIDToFilterBuilderKey,
      mixpanel,
    } as FilterByCellValueParams);
  });

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  const columns = useMemo(
    () =>
      compact([
        {
          type: 'hamburgerMenu',
          id: 'rowMenu',
          params: {
            renderItems: params => <HamburgerMenu {...params} onShowJson={handleClickJson} />,
          },
        },
      ] satisfies ColumnDef<Exposure>[]),
    [handleClickJson]
  );

  return {
    columns,
    getCustomContextMenuItems,
    dialogs,
  };
}
